@for (pract of practitioners(); track pract.id; let idx = $index) {
  @let data = getPractitionerData(pract);
  <div class="mb-3">
    <div class="section-header-blue"><i class="bx bx-user-circle"></i> Profesional de la Salud</div>
    <div class="section-body">
      @if (data?.nombreCompleto) {
        <p class="mb-2"><strong>Nombre completo:</strong> {{ data!.nombreCompleto }}</p>
      }
      @if (data?.documento) {
        <p class="mb-2"><strong>Documento:</strong> {{ data!.documento }}</p>
      }
      @if (data?.tipoDocumento) {
        <p class="mb-2">
          <strong>Tipo de documento:</strong> {{ data!.tipoDocumento!.code }} –
          {{ data!.tipoDocumento!.display }}
        </p>
      }
      <p class="mb-2"><strong>Estado:</strong> {{ data?.activo ? 'Activo' : 'Inactivo' }}</p>

      @if (pract.qualification && pract.qualification.length > 0) {
        <hr />
        <p class="mb-2">
          <i class="bx bx-medal"></i> <strong>Cualificaciones Profesionales</strong>
        </p>
        <div class="table-responsive">
          <table class="table table-sm table-bordered mb-0">
            <thead class="table-light">
              <tr>
                <th>#</th>
                <th>Cualificación</th>
                <th>Periodo</th>
              </tr>
            </thead>
            <tbody>
              @for (q of pract.qualification; track $index) {
                <tr>
                  <td>{{ $index + 1 }}</td>
                  <td>{{ q.code?.coding?.[0]?.display || q.code?.text || '—' }}</td>
                  <td>{{ q.period?.start || '—' }} - {{ q.period?.end || 'Actual' }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    </div>
  </div>
  @if (!$last) {
    <hr />
  }
}
